import React, {memo} from "react";

export const IconPlaces = memo(({color}) => {
  return (
    <svg
      className="places-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="16"
      fill="none"
      viewBox="0 0 11 16"
    >
      <path
        fill={color || "#000"}
        d="M10.4 10.8v-.4c0-.343-.257-.907-.511-1.288l-.713-1.068c-.194-.29-.329-.848-.29-1.195l.535-4.815A1.818 1.818 0 008.976.6 1.817 1.817 0 007.6 0H2.8c-.54 0-1.03.214-1.376.6a1.818 1.818 0 00-.445 1.435l.535 4.814c.039.347-.097.905-.29 1.195L.511 9.112C.258 9.493 0 10.058 0 10.4v.4c0 .44.238.825.594 1.034C.328 12.41 0 13.535 0 15.6a.4.4 0 00.8 0c0-2.295.424-3.281.608-3.6H2.4v2a.4.4 0 00.8 0v-2h4v2a.4.4 0 00.8 0v-2h.992c.184.319.608 1.305.608 3.6a.4.4 0 00.8 0c0-2.064-.328-3.191-.594-3.766.355-.209.594-.594.594-1.034zm-1.2.4h-8a.4.4 0 010-.8h8a.4.4 0 010 .8zM1.889 8.487c.294-.442.478-1.2.42-1.727l-.535-4.814a1.026 1.026 0 01.245-.812C2.212.918 2.49.8 2.8.8h4.8c.31 0 .587.118.78.334.193.215.28.504.246.812L8.09 6.76c-.059.528.125 1.286.42 1.728l.712 1.068.03.045-.053-.001h-8l-.053.001.03-.045.713-1.068v-.001z"
      />
      <path fill={color || "#000"} d="M7.2 8h-4a.4.4 0 010-.8h4a.4.4 0 010 .8z" />
    </svg>
  );
});
